import styled from 'styled-components';
import { ShadowBoxDark } from 'app/components';
import { textTransform } from 'utils';

export const SectionInfo = styled.section.attrs({
  className: 's-info'
})`
  flex: 1 0 auto;
  padding: ${({ theme }) => `${theme.indent.l} 0 ${theme.indent.xxl}`};

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.sm.width}) {
    padding: ${({ theme }) => `${theme.indent.m} 0 ${theme.indent.xxl}`};
  }
  .landing-container {
    width: 100%;
    max-width: 1238px;
    margin: 0 auto;
    padding: 0 16px;
  }
`;

export const SectionInfoTitle = styled.h1.attrs({
  className: 's-info__title'
})`
  margin-bottom: ${({ theme }) => theme.indent.m};
  font-size: 2.4rem;
  letter-spacing: 1px;
  color: ${({ theme }) => `${theme.color.textPrimary}`};
  text-transform: ${textTransform};

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.sm.width}) {
    font-size: 2rem;
  }
`;

export const SectionInfoContent = styled(ShadowBoxDark).attrs({
  className: 's-info__content'
})`
  margin-top: ${({ theme }) => theme.indent.m};
  padding: ${({ theme }) => theme.indent.l};

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.md.width}) {
    padding: ${({ theme }) => theme.indent.m};
  }

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.sm.width}) {
    padding: ${({ theme }) => `${theme.indent.m} ${theme.indent.s}`};
  }
`;

export const SectionInfoContentInner = styled.div.attrs({
  className: 's-info__content-inner'
})`
  max-width: 704px;
  margin: 0 auto;

  .list {
    li {
      width: 100%;
    }

    li + li {
      margin-top: ${({ theme }) => theme.indent.s};
    }
  }

  .marked-li {
    display: flex;
    align-items: flex-start;

    &::before {
      content: '';
      width: 24px;
      height: 24px;
      padding: 5px;
      flex-shrink: 0;
      margin-right: ${({ theme }) => theme.indent.s};
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 78.369 78.369'%3E%3Cpath fill='%23de1619' d='M78.049 19.015L29.458 67.606a1.094 1.094 0 0 1-1.548 0L.32 40.015a1.094 1.094 0 0 1 0-1.547l6.704-6.704a1.095 1.095 0 0 1 1.548 0l20.113 20.112 41.113-41.113a1.095 1.095 0 0 1 1.548 0l6.703 6.704a1.094 1.094 0 0 1 0 1.548z'/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-origin: content-box;
    }
  }

  .heading-1 {
    margin-bottom: ${({ theme }) => theme.indent.s};
    font-weight: 700;
    font-size: 1.6rem;
    text-transform: ${textTransform};
  }

  .heading-2 {
    font-weight: 700;
    font-size: 1.6rem;
    letter-spacing: 0.2px;
  }

  .text-regular {
    color: #fff;
    line-height: 1.5;
    font-size: 1.6rem;
  }

  .text-right {
    text-align: right;
  }

  .text-red {
    color: ${({ theme }) => theme.color.accent};
  }

  .text-gray {
    color: ${({ theme }) => theme.color.labelColor};
  }

  br + br {
    display: none;
  }

  a {
    color: ${({ theme }) => theme.color.accent};
    text-decoration: underline;

    &:hover {
    }
  }

  address {
    display: block;
  }

  i {
    color: ${({ theme }) => theme.color.labelColor};
  }
`;
// TableSection
export const TableSection = styled.div`
  margin: 30px 0px;
  table.price_list_table{
    border-collapse: collapse;
    width: 100%;
  }
  img.logo_img {
    width: 100px;
}
  table.price_list_table th {
    color: #DE1619;
    font-size: 18px;
    text-align: left;
    text-transform: ${textTransform};
    padding: 20px 15px 20px 15px;
  }
  table.price_list_table tbody tr td {
    font-size: 18px;
    font-weight: 390;
    line-height: 24px;
    padding: 20px 15px;
  }
  table.price_list_table tbody tr {
    border-bottom: 1px solid #323232;
  }
  table.price_list_table th.price-title ,
  table.price_list_table tbody td.price-cell {
    text-align: right;
  }
  a.price_link {
    color: #DE1619;
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
    text-decoration-line: underline;
    /* text-align: right; */
  }
  @media (max-width: 441px){
     table.price_list_table tbody tr td {
      font-size: 16px;
    }
    table.price_list_table tbody tr td {
      font-size: 14px;
    }
    a.price_link{
      font-size: 14px;
    }
    tbody tr td:first-child, thead tr th:first-child {
      display: none;
    }
    table.price_list_table th, table.price_list_table tbody tr td {
      padding-left: 0px;
    }
  }
`;

export const ListDetail = styled.div`
span {
  // color: #888888;
  // margin-bottom: 20px;
  // display: block;
}
p, span {
  // font-style: normal;
  // font-weight: 390;
  // font-size: 16px;
  // line-height: 24px;
  // letter-spacing: 1px;
}
`;

export const SectionTop = styled.div`

li{
  display: list-item;
  list-style: inherit;
}
ul {
  margin-left:43px;
}
a{
  text-decoration: underline;
  color:#DE1619;
}

a span{
  color:#DE1619 !important;
}
`;